var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "backgroundPicker",
      on: {
        mousedown: function ($event) {
          $event.stopPropagation()
        },
        touchstart: function ($event) {
          $event.stopPropagation()
        },
      },
    },
    [
      _vm.isLoading
        ? _c("div", { staticClass: "loadWrapper" }, [
            _c("div", { staticClass: "loading" }, [
              _c("span", [_vm._v(_vm._s(_vm.$t("loading")))]),
              _vm._v(" "),
              _c("div", { staticClass: "loadingBar" }),
            ]),
          ])
        : _c(
            "ul",
            { staticClass: "picker three" },
            _vm._l(_vm.collection, function (model, index) {
              return _c("li", { key: index, staticClass: "pickerItem" }, [
                _c(
                  "span",
                  {
                    staticClass: "pattern",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.selectBackground(model)
                      },
                    },
                  },
                  [
                    _c("svg", { attrs: { viewBox: "0 0 80 60" } }, [
                      model.color
                        ? _c("rect", {
                            attrs: {
                              width: "80",
                              height: "60",
                              fill: model.color,
                              stroke: "#ddd",
                              "stroke-width": "1",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      model.image
                        ? _c("defs", [
                            _c(
                              "pattern",
                              {
                                attrs: {
                                  id: "pattern" + index,
                                  patternUnits: "userSpaceOnUse",
                                  width: "100%",
                                  height: "100%",
                                },
                              },
                              [
                                _c(
                                  "image",
                                  _vm._b(
                                    {
                                      attrs: {
                                        width: "100%",
                                        height: "100%",
                                        preserveAspectRatio: "xMidYMid slice",
                                      },
                                    },
                                    "image",
                                    {
                                      "xlink:href": _vm.convertUrl(model.image),
                                    },
                                    false
                                  )
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      model.image
                        ? _c("rect", {
                            attrs: {
                              width: "80",
                              height: "60",
                              fill: "url(#pattern" + index + ")",
                              stroke: "#ddd",
                              "stroke-width": "1",
                            },
                          })
                        : _vm._e(),
                    ]),
                  ]
                ),
                _vm._v(" "),
                (model.image && model.image == _vm.selectedBackground) ||
                (!model.image && model.color == _vm.selectedBackground)
                  ? _c("div", { staticClass: "selectedIcon" }, [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("\n\t\t\t\t\tcheck\n\t\t\t\t"),
                      ]),
                    ])
                  : _vm._e(),
              ])
            }),
            0
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }